<div class="row">
  <div class="col-4">
    @if (foryngringssattItems.length > 0) {
      <rask-simple-selector
        label="Föryngringssätt"
        [values]="foryngringssattItems"
        bindLabel="text"
        bindValue="value"
        class="w-100"
        [disabled]="kontraktReadonly || isMarkberedningSadd() || skogsvardsAtgard.isReadonly"
        (change)="onForyngringssattChanged($event)"
        [(ngModel)]="skogsvardsAtgard.foryngringssatt"
        >
      </rask-simple-selector>
    }
  </div>
  <div class="col-4">
    <rask-input-number
      label="Nettoareal, ha"
      [(ngModel)]="skogsvardsAtgard.nettoareal"
      [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
      (change)="onNettoarealChanged($event)"
      inputGroupRight="ha"
      [isNegative]="false"
      [inputProcessor]="numberDecimalProcessor">
    </rask-input-number>
  </div>
  <div class="col-4">
    @if(isMarkberedningSadd()){
      <rask-input-number
        label="Mål kg/ha"
        [disabled]="true"
        [(ngModel)]="skogsvardsAtgard.malFrogivaHa"
        [isDecimal]="true"
        [useDecimalProcessor]="true">
      </rask-input-number>
    }
    @else
    {
    <rask-input-number
      label="Mål PL/ha"
      [disabled]="!canEditMalPlantorHa() || kontraktReadonly || skogsvardsAtgard.isReadonly"
      [(ngModel)]="skogsvardsAtgard.malPlantorHa"
      (change)="onMalPlantorHaChange($event)"
      [isDecimal]="false"
      [useDecimalProcessor]="true">
    </rask-input-number>
  }
</div>
</div>
@if (showForyngring()) {
  <rask-skogsvard-detaljer-mb-for></rask-skogsvard-detaljer-mb-for>
}